/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Caveat_BankdiffInputs */

const vi_cashflow_caveat_bankdiff = /** @type {(inputs: Cashflow_Caveat_BankdiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chênh lệch NH là ước lượng theo kỳ (có thể lệch do ghi nhận tay hoặc thời điểm tiền về ở biên ngày) — xem màn Đối soát CK để biết chính xác CK chưa gán.`)
};

/**

* @param {Cashflow_Caveat_BankdiffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_caveat_bankdiff = /** @type {((inputs?: Cashflow_Caveat_BankdiffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Caveat_BankdiffInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_caveat_bankdiff(inputs)
});